<script>
export default {
    name: 'headerTop',
    data() {
        return {

        };
    },
    methods: {

    }
}
</script>

<template>
    <div class="header-top">
        <div class="container">
            <div class="header-top__content">
                <ul class="header-top__list">
                    <li class="header-top__item"><a class="header-top__link" >Ростов-на-Дону<img
                                src="../../assets/image/arrow-downBlack.svg" alt=""></a></li>
                    <li class="header-top__item"><a class="header-top__link" >Чат с поддержкой</a></li>
                    <li class="header-top__item"><a class="header-top__link" >Для компаний</a></li>
                    <li class="header-top__item"><a class="header-top__link" >Для сотрудников</a></li>
                    <li class="header-top__item"><a class="header-top__link" >Для ВУЗов и онлайн-школ</a></li>
                    <li class="header-top__item"><a class="header-top__link" >Для HR-агентов</a></li>
                </ul>
            </div>
        </div>
    </div>
</template>

<style scoped>
.header-top {
    background: #E7ECEE;
    padding: 11px 0;
    margin-bottom: 30px;
}

.header-top__link {
    display: flex;
    align-items: center;
    gap: 5px;
    color: #1A1A1A;
    font-family: Aeroport;
    font-size: 14px;
    font-style: normal;
    font-weight: 300;
    line-height: normal;
}

.header-top__list {
    display: flex;
    gap: 50px;
}
@media (max-width: 1440px) {
    .header-top__list {
        gap: 20px;
    }
} 
@media (max-width: 991px) {
    .header-top {
        display: none;
    }
}
</style>